export interface InventoryAgeBucketDTO {
  ageBucket: string | null;
  count    : number | null;
  label    : string | null;
}

export function InventoryAgeBucketDTO_EmptyObject(): InventoryAgeBucketDTO {
  return {
    ageBucket: null,
    count    : null,
    label    : null
  };
}

export interface InventoryDeviceCountByStatusDTO {
  statuses: InventoryStatusCountDTO[] | null;
  total   : number                    | null;
}

export function InventoryDeviceCountByStatusDTO_EmptyObject(): InventoryDeviceCountByStatusDTO {
  return {
    statuses: null,
    total   : null
  };
}

export interface InventoryDeviceDetailDTO {
  assetId       : string | null;
  assignedTo    : string | null;
  distributor   : string | null;
  imei          : string | null;
  make          : string | null;
  model         : string | null;
  notes         : string | null;
  phoneNumber   : string | null;
  purchaseDate  : string | null;
  serialNumber  : string | null;
  simNumber     : string | null;
  status        : string | null;
  warrantyExpiry: string | null;
}

export function InventoryDeviceDetailDTO_EmptyObject(): InventoryDeviceDetailDTO {
  return {
    assetId       : null,
    assignedTo    : null,
    distributor   : null,
    imei          : null,
    make          : null,
    model         : null,
    notes         : null,
    phoneNumber   : null,
    purchaseDate  : null,
    serialNumber  : null,
    simNumber     : null,
    status        : null,
    warrantyExpiry: null
  };
}

export interface InventoryDeviceSummaryDTO {
  assetId     : string | null;
  assignedTo  : string | null;
  id          : string | null;
  make        : string | null;
  model       : string | null;
  purchaseDate: string | null;
  status      : string | null;
}

export function InventoryDeviceSummaryDTO_EmptyObject(): InventoryDeviceSummaryDTO {
  return {
    assetId     : null,
    assignedTo  : null,
    id          : null,
    make        : null,
    model       : null,
    purchaseDate: null,
    status      : null
  };
}

export interface InventoryDeviceCountByModelResultDTO {
  modelledTotal: number | null;
  models       : InventoryModelCountDTO[];
}

export function InventoryDeviceCountByModelResultDTO_EmptyObject(): InventoryDeviceCountByModelResultDTO {
  return {
    modelledTotal: null,
    models       : []
  };
}

export interface InventoryLinkStatusDTO {
  linked: boolean | null;
}

export function InventoryLinkStatusDTO_EmptyObject(): InventoryLinkStatusDTO {
  return {
    linked: null
  };
}

export interface InventoryModelCountDTO {
  count: number | null;
  make : string | null;
  model: string | null;
}

export function InventoryModelCountDTO_EmptyObject(): InventoryModelCountDTO {
  return {
    count: null,
    make : null,
    model: null
  };
}

export interface InventoryRegistrationHistoryDTO {
  cumulativeTotal : number | null;
  newRegistrations: number | null;
  period          : string | null;
}

export function InventoryRegistrationHistoryDTO_EmptyObject(): InventoryRegistrationHistoryDTO {
  return {
    cumulativeTotal : null,
    newRegistrations: null,
    period          : null
  };
}

export interface InventoryStatusCountDTO {
  count : number | null;
  status: string | null;
}

export function InventoryStatusCountDTO_EmptyObject(): InventoryStatusCountDTO {
  return {
    count : null,
    status: null
  };
}

export interface InventoryWarrantyBucketDTO {
  count         : number | null;
  label         : string | null;
  warrantyBucket: string | null;
}

export function InventoryWarrantyBucketDTO_EmptyObject(): InventoryWarrantyBucketDTO {
  return {
    count         : null,
    label         : null,
    warrantyBucket: null
  };
}
